import { useSelector } from "../../store";
import {
  useGetEventVideoGroups,
  useGetEventVideoGroupsSets,
} from "./videojsComponent/multiAngle/useVideoGroupsSet";

import type { EventVideo } from "@spwn/types/firebase/firestore";

/**
 * 現在視聴中のビデオが属するVideoGroupsSet以外のVideoGroupsSetsのメインビデオのリストを取得する
 */
export const useGetMainVideosOfVideoGroupsSetsWithoutCurrentSets = (
  currentVideoId: string,
  eventVideoList: EventVideo[]
): EventVideo[] => {
  const eventVideoMap = useSelector((state) => state.streaming.eventVideoMap);
  const { data: videoGroups = {} } = useGetEventVideoGroups(eventVideoMap);
  const { data: videoGroupsSets = {} } =
    useGetEventVideoGroupsSets(videoGroups);

  const currentVideo = eventVideoMap
    ? eventVideoMap[currentVideoId]
    : undefined;

  const currentVideoGroups = currentVideo?.videoGroupRef?.id
    ? videoGroups[currentVideo?.videoGroupRef?.id]
    : undefined;

  const currentVideoGroupsSets =
    currentVideoGroups === undefined
      ? undefined
      : videoGroupsSets[currentVideoGroups.videoGroupsSetRef.id];

  const videoGroupsSetsList = Object.values(videoGroupsSets).flatMap((set) => {
    if (currentVideoGroupsSets?._id === set._id) {
      return [];
    }

    const mainVideoId = set.mainVideoRef.id;

    const mainVideo = eventVideoList.find((video) => video._id === mainVideoId);

    if (mainVideo === undefined) {
      return [];
    }

    return {
      ...mainVideo,
      name: set.name,
    };
  });

  return videoGroupsSetsList;
};
